<template>
  <LayoutMinimal>
    <div
            id="confirm_email"
    >
      <div class="image"></div>
      <Spinner v-if="loading"/>
      <div class="content" v-else>
        <div
                class="confirmed"
                v-if="confirmedEmail"
        >
          <h4>
            {{$t('confirm_email.title')}}
          </h4>
          <p>
            {{$t('confirm_email.subtitle')}}
          </p>

          <div class="action-container">
            <div class="go-to-login">
              <router-link
                      :to="{name: 'login'}"
                      class="btn btn-login"
              >
                {{$t('confirm_email.buttons.go_to_login')}}
              </router-link>
            </div>
          </div>
        </div>
        <div
                class="errors"
                v-else
        >
          <p
                  v-for="confirmEmailError in confirmEmailErrors"
                  :key="confirmEmailError"
          >
            {{confirmEmailError}}
          </p>
        </div>
      </div>
    </div>
    <template slot="after">
      <Footer/>
    </template>
  </LayoutMinimal>
</template>

<script>
    import Spinner from "../components/Spinner";
    import EventBus from '../eventbus';
    import LayoutMinimal from "../layouts/LayoutMinimal";
    import Footer from "../components/Footer";

    export default {
      components: {
        LayoutMinimal,
        Spinner,
        Footer,
      },
      data(){
        return {
            loading: true,
            confirmEmailErrors: [],
            confirmedEmail: false,
        }
      },
      methods:{
          confirmEmail(){
              return this.$http.post('auth/verify_email', {
                  email: this.$route.query.email,
                  token: this.$route.query.token
              });
          },
      },
      mounted(){
          this.confirmEmail()
            .then(() => {
                this.confirmedEmail = true;

                if(this.$auth.check()){
                    this.$router.push({name: 'dashboard'});
                }else{
                    this.loading = false;
                }

            }).catch(() => {
                this.loading = false;
                this.confirmEmailErrors = [this.$t('login.verify_email_error')];
            });
      }
    }
</script>

<style scoped lang="scss">
  @import '../styles/variables';
  @import '../styles/classes';

  #confirm_email{
    display: block;
    padding: 9px;
    min-width: 300px;
    text-align: center;

    @media(max-width: 400px){
      width: 100vw;
    }

    .content{
      text-align: center;
    }

    .image{
      align-self: center;
      flex: 2;
      height: 300px;
      width: 100%;
      background-image: url(/img/subscribe_girl.png);
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }

    .btn.btn-login{
      @extend %fresh-btn;
    }
  }
</style>
